import React, { useRef, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Download } from 'lucide-react';
import {
  Card, CardHeader, CardTitle, CardMeta, HeaderRight, ExportBtn, EmptyState, Skeleton,
} from '../styles';
import { exportCardPng } from '../exportCardPng';

// Shared card frame: title, right-side meta, PNG export button (excluded from
// the capture itself), loading skeleton and empty state handling.
// (Copied verbatim from leave-dashboard/components/DashboardCard.js per brief —
// third copy of this frame across the three dashboards is accepted; extracting
// a shared component would touch two already-shipped pages.)
export default function DashboardCard({
  cardKey,
  title,
  meta,
  span,
  spanMd,
  loading,
  empty,
  emptyText,
  headerExtra,
  domId,
  children,
}) {
  const { t } = useTranslation();
  const cardRef = useRef(null);

  const handleExport = useCallback(() => {
    exportCardPng(cardRef.current, cardKey).catch(() => {});
  }, [cardKey]);

  return (
    <Card ref={cardRef} id={domId} $span={span} $spanMd={spanMd}>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        <HeaderRight>
          {meta ? <CardMeta>{meta}</CardMeta> : null}
          {headerExtra}
          <ExportBtn
            type="button"
            data-export-exclude
            onClick={handleExport}
            title={t('atsDashboard.export.saveAsPng')}
            aria-label={t('atsDashboard.export.saveAsPng')}
          >
            <Download size={15} />
          </ExportBtn>
        </HeaderRight>
      </CardHeader>
      {loading ? <Skeleton /> : empty ? <EmptyState>{emptyText || t('atsDashboard.empty')}</EmptyState> : children}
    </Card>
  );
}
